import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from '../forms/FormMixin'
import useGlobal from '../../composables/useGlobal'
import { orderRetrieveResource, orderPaymentResource } from '@/services/order.service'
import executeWithRefresh from '@/composables/useRefresher'
import useDeviceInfo from '@/composables/useDevice'
import { storage } from '@/utils/session'
import { STATE } from '@/utils/base64'
import { sendCompletePayment } from '@/analytics/CompletePayment'
import {
  HQ_VPN_CURRENT_PAYMENT_ID_NAME,
} from '@/const'


export default /*#__PURE__*/_defineComponent({
  __name: 'Success',
  props: ['user_key'],
  setup(__props, { expose }) {
  expose();

const props = __props

const { $t } = useGlobal()

const parseGetParams = () => {
  if (window.location.search) {
    const [search] = window.location.search.substring(1).split('&')
    const result = STATE.parse(search);
    console.log(result);
    return result
  }
}

const checkMethod = async () => {
  const { order_id, subscription_key, service } = parseGetParams()
  if (window.location.search && order_id) {
    const prepearedData = {
      id: order_id
    }
    try {
      sendCompletePayment(subscription_key, service)
      const res = (await executeWithRefresh(orderRetrieveResource, null, prepearedData))
      const data = (await executeWithRefresh(orderPaymentResource, null, { id: storage.getItem(HQ_VPN_CURRENT_PAYMENT_ID_NAME) }))
    } catch(e) {
      return Promise.reject(e)
    }
  }
}

onMounted(() => {
  checkMethod()
})

  
const __returned__ = { $t, props, parseGetParams, checkMethod, ref, onMounted, useSubmit, useGlobal, orderRetrieveResource, orderPaymentResource, executeWithRefresh, useDeviceInfo, storage, STATE, sendCompletePayment, HQ_VPN_CURRENT_PAYMENT_ID_NAME }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})